<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { frontendUrl } from '@/config';
import languageToSlug from '@/helpers/languageToSlug';
import AddEditForm from '@/components/regions/AddEditForm';
import SingleView from '@/components/elements/views/SingleView';

export default {
    page: {
        title: 'Manage Region'
    },

    components: {
        AddEditForm
    },

    extends: SingleView,

    validations: {
        item: {
            name: {
                required
            },
            slug: {
                required
            }
        },
        language: {
            id: {
                required
            }
        }
    },

    data() {
        return {
            backRoute: '/regions',
            indexName: 'Regions',
            singleItemName: 'region',
            languagePicker: true
        };
    },

    computed: {
        itemInformationOptions() {
            return { slugBasicUrl: 'regions' };
        },

        previewUrl() {
            const { slug, language } = this.item;

            const languageSlug = languageToSlug(language);

            const url = frontendUrl.concat(languageSlug);

            return url.concat(`/branches/regions/${slug}`);
        }
    },

    methods: {
        ...mapActions({
            addItem: 'regions/store',
            deleteItem: 'regions/destroy',
            getItem: 'regions/show',
            updateItem: 'regions/update'
        })
    }
};
</script>
